/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDashboardLayoutItem } from './ReportDashboardLayoutItem';
import type { ReportUserAssignmentRankingFilters } from './ReportUserAssignmentRankingFilters';
import type { ReportWidgetAccentColor } from './ReportWidgetAccentColor';
import type { ReportWidgetValidation } from './ReportWidgetValidation';
/**
 * Persisted user assignment ranking widget instance.
 */
export type ReportUserAssignmentRankingWidgetInstance = {
    /**
     * Stable widget instance identifier.
     */
    id: string;
    /**
     * Discriminator for the user assignment ranking widget.
     */
    kind: ReportUserAssignmentRankingWidgetInstance.kind;
    /**
     * Optional user-facing title override.
     */
    title?: string;
    /**
     * Optional short badge label shown on the widget card.
     */
    label?: string;
    /**
     * Optional semantic accent color used to tint the widget card and badge.
     */
    color?: ReportWidgetAccentColor;
    /**
     * Saved layout metadata for the widget instance.
     */
    layout: ReportDashboardLayoutItem;
    /**
     * Validation result resolved from the current tenant state.
     */
    validation?: ReportWidgetValidation;
    /**
     * Saved filters for the user assignment ranking widget.
     */
    filters: ReportUserAssignmentRankingFilters;
};
export namespace ReportUserAssignmentRankingWidgetInstance {
    /**
     * Discriminator for the user assignment ranking widget.
     */
    export enum kind {
        USER_ASSIGNMENT_RANKING = 'USER_ASSIGNMENT_RANKING',
    }
}

